import React from 'react';

import Vote from './Vote';

function Votes(props) {
  var votes = props.votes.map((vote) => {
    let voter = props.voters.find(voter => {
      return vote.voter.id == voter.id;
    });

    return (
      <Vote key={vote.id} vote={vote} voter={voter} />
    )
  })

  return (votes);
}

export default Votes;
